import { createRecipe } from './runtime.js';

const checkboxGroupConfig = {"name":"checkboxGroup","defaultVariants":{"orientation":"vertical"},"compoundVariants":[{"orientation":"vertical","size":"md","className":"checkboxGroup--compound__orientation_vertical__size_md"}],"variantMap":{"orientation":["horizontal","vertical"],"size":["md","sm"]}}

export const checkboxGroup = /* @__PURE__ */ createRecipe(checkboxGroupConfig)